import { render, staticRenderFns } from "./FeaturedInList.vue?vue&type=template&id=c1522eda&scoped=true&"
import script from "./FeaturedInList.vue?vue&type=script&lang=js&"
export * from "./FeaturedInList.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedInList.vue?vue&type=style&index=0&id=c1522eda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1522eda",
  null
  
)

export default component.exports